import React, { ReactElement, useState } from 'react';
import { FormLayout, ChoiceList, Scrollable, Link, Button, Thumbnail, Card, Divider, BlockStack, Bleed, InlineStack, Text, Layout, RadioButton, Box, InlineError, Spinner } from '@shopify/polaris';
import { DI, DIProps } from '../../../../../Core';
import { MobilePlusMajor, DeleteMinor } from '@shopify/polaris-icons';
import { SortableContainer, SortableElement, SortableHandle } from 'react-sortable-hoc';
import useContextLayer from '../../Context/helper';
import { ACTION_TYPE } from '../../Context/actiontypes';
import { defaultImage, getSelectedImagesCount, showErrorSymbol, useParentErrors } from '../../utils/utils';
import useContainerState from '../../Context/ContainerState';
import "./Images.css";
import { useTranslation } from 'react-i18next';
import Noimage from '../../../../../Asests/Images/no-image-new.png'
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css'; // Import blur effect
import { modifyImageUrl } from './../../../Listing Grid/Utilities/Helper';
import getClass from '../../../../Utilities/getClass';


interface Props extends DIProps { validatorError: any }

function Image(props: Props): ReactElement {
  const { t } = useTranslation();
  const { state, dispatch } = useContextLayer();
  const { containerState } = useContainerState();
  const DragHandle = SortableHandle(() => <div className='overlay'></div>);
  const [imageState, setImageState] = useState(state['selected_images']);

  const onSortEnd = (params: any) => {
    let { oldIndex, newIndex } = params;
    let tempArr = [...state?.['selected_images']]
    let tempUrl = state?.['selected_images'][oldIndex];
    tempArr[oldIndex] = state?.['selected_images'][newIndex];
    tempArr[newIndex] = tempUrl;
    let shouldSort = getSelectedImagesCount(state?.selected_images);
    (shouldSort.length <= 9 && shouldSort.length > 1 && state?.selected_images[newIndex] != defaultImage) &&
      dispatch({
        type: ACTION_TYPE.REPLACE_IMAGE,
        payload: {
          [ACTION_TYPE.SELECTED_IMAGES]: tempArr,
          newIndex: newIndex,
          oldIndex: oldIndex,
          replace: true,
          originalState: imageState
        }
      });
  };


  function removeImage(imageUrl: string = '') {
    dispatch({
      type: ACTION_TYPE.DELETE_IMAGE,
      payload: {
        delete_image: imageUrl,
        [ACTION_TYPE.SELECTED_IMAGES]: state?.['selected_images'],
      }
    })
  }
  const SortableListItem = SortableElement<any>((params: any = []) => {
    return (
      <div className='w-33' key={params['item']}>
        <div className='custom-card p-8 h-100' key={params['item'] + 'custom-card'}>
          <BlockStack gap="300">
            <div className="container">
              <img width="100%" alt='product thumbnail' src={params['item'] != '' ? params['item'] : Noimage} key={params['item'] + 'img'} />
              {/* <Thumbnail
                source={params['item'] != '' ? params['item'] : Noimage}
                alt={"productThumbnails" + params['item']}
                size='medium'
              /> */}
              <DragHandle />
              {params['item'] != defaultImage &&
                <Button icon={DeleteMinor} onClick={() => {
                  removeImage(params['item']);
                }}></Button>}
            </div>
            {params['item'] === state.selected_images[0] && state.selected_images[0] != defaultImage && <Text as='p' tone="success">{t("Primary Image")}</Text>}
          </BlockStack>
        </div>
      </div>
    );
  });

  const SortableList = SortableContainer<any>(({ items }: any = []) => {
    return (
      <div className="Layout" key={'SortableContainer'}>
        {items?.map((item: any, index: any) => {
          return (
            <React.Fragment key={index}>
              <SortableListItem axis="xy" index={index} item={item} disabled={item === defaultImage} />
            </React.Fragment>
          );
        })}
      </div>
    );
  });

  function addToMainImage(url: string = '', index: number = 0) {
    let shouldAddImage = getSelectedImagesCount(state?.selected_images);
    shouldAddImage?.length < 9 ?
      dispatch({
        type: ACTION_TYPE.SELECTED_IMAGES,
        payload: {
          [ACTION_TYPE.SELECTED_IMAGES]: url,
          originalState: imageState
        }
      })
      : props.error(t("Cannot add more than 9 images"));
  }

  function renderAdditionalImages() {
    if (Object.keys(state?.['shopify_images'])?.length > 0) {
      return state?.['shopify_images'].map((url: string, index: number) => url != '' && <div key={index} className='w-33'>
        <div className={state['selected_images'].includes(url) ? 'overlay-conainter' : ''}>
          <div style={{ cursor: 'pointer' }} className={state['selected_images'].includes(url) ? 'overlay-child' : ''} title={t('Click to upload image')} onClick={() => {
            addToMainImage(url, index)
          }} key={index + 'image'} >
            <Thumbnail alt='productImages' source={url} size="small" key={index + 'Thumbnail'} />
          </div>
        </div>
      </div>)
    }
    else return <Text as="p">{t("Sorry no addition images were found")}!</Text>
  }

  function renderMainImage() {
    return <div className="w-70" key={'renderMainImage'}>
      <SortableList lockToContainerEdges useDragHandle axis={"xy"} items={state?.['selected_images']} onSortEnd={onSortEnd} key='sortableList' />
    </div>
  }

  function uploadImages() {
    dispatch({
      type: ACTION_TYPE.MODAL_ACTION,
      payload: {
        open: true,
        title: t('Add More Images'),
        type: 'imageupload',
        content: t('Choose Image')
      }
    })
  }

  function knowMoreOnUploadingImages() {
    dispatch({
      type: ACTION_TYPE.MODAL_ACTION,
      payload: {
        open: true,
        title: t('Image Upload Tutorial'),
        type: 'knowmoreonuploadingimages'
      }
    })
  }

  function renderImageFooter() {
    return <>
      <Bleed marginInline="500"><Divider /></Bleed>
      <InlineStack align="space-between" blockAlign="center">
        <Link onClick={() => { knowMoreOnUploadingImages() }}>{t("Know more on uploading files")} </Link>
        <Button icon={MobilePlusMajor} onClick={() => {
          if (state?.shopify_images?.length > 19) { //don't allow more than 20 images in s3 bucket
            props.error(t("Can't add more than 20 images"))
          }
          else uploadImages()
        }}>{t("Add More Images")}</Button>
      </InlineStack>
    </>;
  }

  let errors = useParentErrors(state, containerState.initialProductData['hasVariants']);
  function renderImageSelection() {
    let shouldAddImage = getSelectedImagesCount(state?.selected_images);
    return (
      // <div className={errors?.['image_selection'] ? 'custom-error-description' : ''}>
      <BlockStack gap="600" key={'TextConatainer'}>
        <Text as='h2' variant='headingMd'>{t("Choose Images by clicking them")}</Text>
        <Text as="p">
          {t("You can select upto 9 Images. If required, add more Images using the add Image action. Selected Images will be displayed in the below section.")}
        </Text>
        <div className='Layout' key={'top-level-layout'}>
          {renderMainImage()}
          <div className='w-30' key={'w-30'}>
            <Scrollable shadow style={{ height: '425px' }} key='scrollable'>
              <div className='Layout'>
                {renderAdditionalImages()}
              </div>
            </Scrollable>
          </div>
        </div>
        {/* {errors?.['image_selection'] && props?.validatorError?.image_selection ? <InlineError fieldID='inlineErrorImage' message={props.validatorError['image_selection']} /> : errors?.['image_selection'] ? <InlineError fieldID='inlineErrorImages' message={t("Images can't be empty")} /> : <Text as="p">{t("Selected Image")} : {shouldAddImage?.length ?? 0} / 9</Text>} */}
        {errors?.['image_selection'] || props?.validatorError?.image_selection ? <InlineError fieldID='inlineErrorImage' message={props?.validatorError?.['image_selection'] ? props?.validatorError?.['image_selection'] : t("Images can't be empty")} /> : <Text as="p">{t("Selected Image")} : {shouldAddImage?.length ?? 0} / 9</Text>}
      </BlockStack>
      // </div>
    );
  }

  const shopify_images: any = [state?.shopify_data?.main_image ?? '', ...state?.shopify_data?.additional_images ?? []].filter(a => a);
  shopify_images?.uniqueArray();

  return <>
    {Object.keys(state).length > 0 && <div id='tour_images'>
      <Card roundedAbove='sm'>
        <Layout>
          <Layout.AnnotatedSection
            id="productimages"
            title={t("Images")}
            // title={showErrorSymbol(state, 'image_selection', t("Images"))}
            description={t("Select the best image combinations or add new images (a maximum of 9) for your product displayed as part of the product images when it gets uploaded on Amazon.")}
          >
            <div className={(errors?.['image_selection'] || props?.validatorError?.image_selection) ? 'Custom-Polaris-Box custom-error-description' : 'Custom-Polaris-Box'}>
              <Box padding='400' background="bg-surface-secondary" borderRadius='300' borderWidth='025' borderColor='border'>
                <BlockStack gap="300">
                  <InlineStack gap="300">
                    <RadioButton
                      label={t("Set Product Images as shown on Shopify")}
                      id="imgdefault"
                      name="img"
                      checked={(state?.['selection_type']?.['image_selection'] ?? 'default') === 'default'}
                      onChange={() => {
                        dispatch({
                          type: 'selection_type',
                          payload: {
                            image_selection: 'default'
                          }
                        });
                      }}
                    />
                    <RadioButton
                      label={t("Set Custom ‘Images’ for Amazon")}
                      id="imgcustom"
                      name="img"
                      checked={(state?.['selection_type']?.['image_selection'] ?? 'default') === 'custom'}
                      onChange={() => {
                        dispatch({
                          type: 'selection_type',
                          payload: {
                            image_selection: 'custom'
                          }
                        });
                      }}
                    />
                  </InlineStack>
                  {state?.selection_type?.image_selection === 'default' && <Box padding='200' background='bg-fill-disabled'>
                    <BlockStack gap='200'>
                      <Text as='p' tone='subdued'>{shopify_images?.length} {t("image(s) are added in Shopify.")}</Text>
                      <InlineStack wrap gap='200'>
                        {shopify_images.map((img: string, index: number) => {
                          return <LazyThumbnail
                            src={img ? modifyImageUrl(img) : Noimage}
                            // src={img}
                            alt='productImages'
                            key={index + 'Thumbnail'}
                            size='medium'
                          />
                          // return <Thumbnail alt='productImages' source={img} key={index + 'Thumbnail'} />
                        })}
                      </InlineStack>
                    </BlockStack>
                  </Box>}
                  {state?.selection_type?.image_selection === 'custom' && renderImageSelection()}
                  {state?.selection_type?.image_selection === 'custom' && renderImageFooter()}
                </BlockStack>
              </Box>
            </div>
          </Layout.AnnotatedSection>
        </Layout>
        {/* <BlockStack gap="400">
          <Text variant='headingMd' as='h6'>
            {showErrorSymbol(state, 'image_selection', "Images")}
          </Text>
          <Text as='p'>
            {t("Select the best image combinations or add new images (a maximum of 9) for your product displayed as part of the product images when it gets uploaded on Amazon.")}
          </Text>
          <FormLayout>
            <ChoiceList
              title=""
              choices={[
                { label: t('Set Product Images as shown on Shopify'), value: 'default' },
                { label: t('Set Custom Images for Amazon'), value: 'custom' },
              ]}
              selected={state?.['selection_type']?.['image_selection'] ?? 'default'}
              onChange={(id) => {
                dispatch({
                  type: 'selection_type',
                  payload: {
                    image_selection: id.toString()
                  }
                });
              }}
            />
            {state?.selection_type?.image_selection === 'custom' && renderImageSelection()}
          </FormLayout>
          {state?.selection_type?.image_selection === 'custom' && renderImageFooter()}
        </BlockStack> */}
      </Card>
    </div>}
  </>;
}

export default DI(Image);

export const LazyThumbnail = ({ src, alt, size = "large", className = "" }: { src: string; alt: string, className?: string, size?: "small" | "medium" | "large" }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  return (
    <div className={getClass({ "thumbnail": true, [size]: size, [className]: className })}>
      {/* Show spinner until the image is loaded */}
      {!isLoaded && (
        <div className="thumbnail-placeholder">
          <Spinner size="small" />
        </div>
      )}
      <LazyLoadImage
        src={src}
        alt={alt}
        height={'100%'}
        effect="blur"
        className="lazy-thumbnail-image"
        afterLoad={() => setIsLoaded(true)}
      />
    </div>
  );
};